import { createElement, lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Footer from './Footer';
import Header from './Header';
import Nav from './Nav';
import LoadingIndicator from './components/LoadingIndicator';
import { APP_ROUTE_PATHS } from './routes';
import './App.css';

const pages = [
  lazy(() => import('./pages/Stories')),
  lazy(() => import('./pages/Story')),
  lazy(() => import('./pages/Weather')),
  lazy(() => import('./pages/Sports')),
  lazy(() => import('./pages/Lottery')),
  lazy(() => import('./pages/Horoscope')),
  lazy(() => import('./pages/PropagandaMachine')),
  lazy(() => import('./pages/Archive')),
  lazy(() => import('./pages/About')),
  lazy(() => import('./pages/Privacy')),
  lazy(() => import('./pages/Download')),
  lazy(() => import('./pages/Beta')),
  lazy(() => import('./pages/NotFound')),
];

export function AppRoutes() {
  return (
    <Suspense fallback={<LoadingIndicator />}>
      <Routes>
        {APP_ROUTE_PATHS.map((path, index) => (
          <Route key={path} path={path} element={createElement(pages[index])} />
        ))}
      </Routes>
    </Suspense>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Header />
        <Nav />
        <AppRoutes />
      </div>
      <Footer />
    </BrowserRouter>
  );
}
